export const BOOTSTRAP = 'crm/BOOTSTRAP'

export const FETCH_CRM_COUNTS_REQUEST = 'crm/FETCH_CRM_COUNTS_REQUEST'
export const FETCH_CRM_COUNTS_SUCCESS = 'crm/FETCH_CRM_COUNTS_SUCCESS'
export const FETCH_CRM_COUNTS_FAILURE = 'crm/FETCH_CRM_COUNTS_FAILURE'

export const SORT_CONTACTS = 'crm/SORT_CONTACTS'
export const UPDATE_CONTACTS_PAGE = 'crm/UPDATE_CONTACTS_PAGE'
